import { useRecord } from "./useRecord";
import { useMemo } from "react";
import { generateRecordId } from "libs/schema";

export function useThreadRequest(props: {
  id?: string | null;
  threadId?: string | null;
  senderUserId?: string | null;
  recipientUserId?: string | null;
}) {
  const id = useMemo(() => {
    if (props.id) return props.id;
    if (!props.threadId) return null;
    if (!props.senderUserId) return null;
    if (!props.recipientUserId) return null;

    return generateRecordId("thread_request", {
      thread_id: props.threadId,
      recipient_user_id: props.recipientUserId,
      sender_user_id: props.senderUserId,
    });
  }, [props.id, props.threadId, props.senderUserId, props.recipientUserId]);

  return useRecord("thread_request", id, { name: "useThreadRequest" });
}
